import axios from 'axios'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const FETCH_FINANCIAL_RELATORY_INIT = createAsyncConst(
  'FETCH_FINANCIAL_RELATORY_INIT'
)
export const MAKE_FINANCIAL_RELATORY = createAsyncConst(
  'MAKE_FINANCIAL_RELATORY'
)

export function fetchFinancialRelatoryInit(filters = []) {
  return dispatch => {
    dispatch(action(FETCH_FINANCIAL_RELATORY_INIT.ACTION))
    return axios
      .get(`${config.API_URL}/relatory-financial`, {
        params: {
          filters: JSON.stringify(filters),
        },
      })
      .then(resp => {
        dispatch(
          action(FETCH_FINANCIAL_RELATORY_INIT.SUCCESS, {
            data: resp.data,
            filters,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_FINANCIAL_RELATORY_INIT, e)))
  }
}

export function makeRelatory(data) {
  return dispatch => {
    return axios({
      url: `${config.API_URL}/make-relatory-financial`,
      method: 'POST',
      responseType: 'blob',
      headers: { Accept: 'application/vnd.ms-excel' },
      params: {
        filters: JSON.stringify(data),
      },
    })
      .then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'financial_report.xlsx')
        document.body.appendChild(link)
        link.click()
        return resp
      })
      .catch(e => dispatch(actionFailed(MAKE_FINANCIAL_RELATORY, e)))
  }
}

export function clearFilter() {
  return { type: 'CLEAR_ACTION_FINANCIAL' }
}
